'use client';
export { initialize, track, identify, page, routeChangeHandler, setAnonymousId, } from './main.js';
